// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bank--info[data-v-47423f87]{width:100%;display:flex;align-items:center;border-radius:16px;box-shadow:0 5px 11px 0 rgba(0,0,0,.18),0 4px 15px 0 rgba(0,0,0,.15)}.bank--info .bank--info-image img[data-v-47423f87]{width:120px;height:120px;object-fit:contain;border-bottom-left-radius:.5rem;border-top-left-radius:.5rem;padding:8px}.bank--info .bank--info-name[data-v-47423f87]{font-size:1.4rem}.bank--info .bank--info-description[data-v-47423f87]{font-size:1rem;color:#666}", ""]);
// Exports
module.exports = exports;
